import { render, staticRenderFns } from "./statusopen.vue?vue&type=template&id=40566e12&scoped=true&"
import script from "./statusopen.vue?vue&type=script&lang=js&"
export * from "./statusopen.vue?vue&type=script&lang=js&"
import style0 from "./statusopen.vue?vue&type=style&index=0&id=40566e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40566e12",
  null
  
)

export default component.exports